
import Stepper from 'components/commons/stepper/Stepper.js'
import { ImportData } from './import-step/ImportData.jsx'
import { UploadFile } from './import-step/UploadFile.jsx'
import { ValidateData } from './import-step/ValidateData.jsx'
import { ViewData } from './import-step/ViewData.jsx'
import { useImport } from './ImportContext.jsx'

const STEPS_IMPORT_DATA = ['Upload File', 'Validate Data', 'View Data', 'Import Data']

const ImportContent = () => {
    const { activeStep } = useImport()
    const stepContent = [<UploadFile />, <ValidateData />, <ViewData />, <ImportData />]

    return (
        <div className='flex flex-col items-center py-8 space-y-8 border-t-2 border-neutral-20'>
            <Stepper steps={STEPS_IMPORT_DATA} activeStep={activeStep} />
            {stepContent[activeStep - 1]}
        </div>
    )
}

export default ImportContent
